var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDisabled48Line = function SvgIconDisabled48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.35a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2ZM33.56 37.05l-3.94-6.31c-.35-.56-.95-.89-1.61-.89H26.6a5.31 5.31 0 0 1-5.3-5.3v-6.4h3.4v6.4c0 1.05.85 1.9 1.9 1.9h1.41c1.84 0 3.52.93 4.49 2.49l3.94 6.31-2.88 1.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37.85c-5.35 0-9.7-4.35-9.7-9.7 0-3.75 2.2-7.2 5.61-8.79l1.44 3.08a6.322 6.322 0 0 0-3.64 5.71c0 3.47 2.83 6.3 6.3 6.3 1.68 0 3.27-.66 4.46-1.85l2.4 2.4a9.645 9.645 0 0 1-6.86 2.84l-.01.01Z",
    fill: "current"
  })));
};
export default SvgIconDisabled48Line;